module.exports = __webpack_public_path__ + "src/assets/video/howToPlayMove.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/howToPlayMove.gif
// module id = ./src/assets/video/howToPlayMove.gif
// module chunks = 0